
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'RamsaySedationScale',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/Chart_Ramsay.vue